export const CHAT_INPUT_PLACEHOLDER = 'Type your message here...';
export const CHAT_INITIAL_STATE_TITLE = "Let's chat";
export const CHAT_INITIAL_STATE_DESCRIPTION =
  "Here, you can ask any questions and get answers based on the files in your workspace. Don't forget to give a thumbs up or down to show if the answer was correct.";
export const INVALID_PIPELINE =
  "Make sure that the selected pipeline is generative and it's deployed";
export const UPLOAD_HINT = 'Drag and drop file(s) here or';
export const BROWSE = 'browse';
export const ATTACH_MORE = 'Attach more files';
export const ATTACH_FILES = 'Attach files';
export const UPLOAD_MORE = 'Upload files and more';
export const DISPLAY_UPLOAD = 'Display the upload files panel';
export const ALT_FALLBACK = 'thumbnail of uploaded file';
export const ERROR_UPLOADING = 'Error uploading';
export const ATTACHMENTS = 'Attachments';
